<template>
  <div class="container">
    <div class="title has-text-centered">
      Pending Requests
    </div>

    <FormErrors v-bind:errors="pending_requests.errors.detail" />

    <div class="columns is-centered">
      <div
        class="column is-7"
        style="max-height: min(600px, 60vh); overflow-y: auto;"
      >
        <ul v-if="pending_requests.data.length === 0">
          <li
            class="box has-text-centered is-centered has-text-weight-bold has-background-white"
          >
            No pending requests
          </li>
        </ul>
        <ul v-else>
          <li>
            <div class="columns is-vcentered">
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Name</p>
              </div>
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Project Title</p>
              </div>
              <div class="column"></div>
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Action</p>
              </div>
            </div>
          </li>
          <li
            v-for="(pending_request, index) in pending_requests.data"
            class="box is-rounded mb-4"
            v-bind:key="index"
          >
            <div class="columns is-vcentered">
              <div class="column">
                <router-link
                  v-bind:to="{
                    name: 'MentorProfilePage',
                    params: { profile_uid: pending_request.mentor },
                  }"
                  class="hyperlink"
                >
                  {{ pending_request.mentor_name }}
                </router-link>
              </div>
              <div class="column">
                {{ pending_request.project_title }}
                <br>
                
              </div>
              <div class="column is-narrow">
                <span>{{ get_status(pending_request.status) }} </span>
              </div>
              <div class="column is-narrow">
                <button
                  v-on:click="show_request_details(index)"
                  class="button is-info mr-2"
                >
                  <span class="icon"><i class="fas fa-info"></i></span>
                </button>
                <button
                  v-if="pending_request.status==4"
                  v-on:click="open_send_request_modal(index)"
                  class="button is-success"
                >
                  <span class="icon"><i class="fas fa-undo"></i></span>
                </button>
                <button
                  v-else
                  v-on:click="cancel_pending_request(index)"
                  class="button is-danger"
                >
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>
                
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-bind:class="{
        'is-active': pending_requests.modals.request_details.show,
      }"
      class="modal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Request details</p>
          <button
            v-on:click="pending_requests.modals.request_details.show = false"
            class="delete"
            aria-label="close"
          ></button>
        </header>

        <div class="modal-card-body">
          <div class="content">
            <div>
              <strong>Statement of purpose</strong>
              <p>
                {{
                  pending_requests.modals.request_details.content
                    .statement_of_purpose
                }}
              </p>
            </div>
            <hr />
            <div>
              <strong>Commitment in months</strong>
              <p>
                {{ pending_requests.modals.request_details.content.commitment }}
              </p>
            </div>
            <hr />
            <div>
              <strong>Expectations</strong>
              <p>
                {{
                  pending_requests.modals.request_details.content.expectations
                }}
              </p>
            </div>
            <hr v-if="pending_requests.modals.reject_reason.content.reject_reason.length != 0"/>
            <div v-if="pending_requests.modals.reject_reason.content.reject_reason.length != 0">
              <strong>Reject Reason</strong>
              <p v-if="pending_requests.modals.reject_reason.content.reject_reason.length == 0">
                No data
              </p>
              <p v-else>
                {{
                  pending_requests.modals.reject_reason.content.reject_reason
                }}
              </p>
            </div>
            <hr />
            <div v-if="priorityChecklist" class="control">
              <strong>Priority Checklist</strong>
              <ul style="list-style: none">
                <li v-for="item in priorityChecklist" v-bind:key="item.uid">
                  <label class="checkbox pb-2">
                    <input
                      type="checkbox"
                      v-bind:value="item.uid"
                      disabled="disabled"
                      :checked="isPriorityItemChecked(item.uid)"
                    />
                    {{ item.label }} ({{ PRIORITY_VALUES[item.priority] }})
                  </label>
                </li>
              </ul>
            </div>
            <div class="control" v-if="pending_requests.modals.request_details.content.submission_file_name">
              <strong>Submission by you</strong>
              <br>
              <p v-if="pending_requests.modals.request_details.content.project_title"> 
                <span style="font-weight: bolder;">Project title:</span>{{ pending_requests.modals.request_details.content.project_title }}
              </p>
              <!-- <br> -->
              {{ pending_requests.modals.request_details.content.submission_file_name }}
              <button v-on:click="download_file('submissions/'+pending_requests.modals.request_details.content.submission_file_name)" class="button is-primary">
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        v-bind:class="{ 'is-active': send_request.show_send_request_modal }"
        class="modal"
      >
        <div
          class="modal-background"
          v-on:click="send_request.show_send_request_modal = false"
        ></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Send Request</p>
            <button
              v-on:click="send_request.show_send_request_modal = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>

          <section class="modal-card-body">
            <InputBox
              input_type="textarea"
              v-model="send_request.modal.statement_of_purpose"
              v-bind:errors="send_request.modal_errors.statement_of_purpose"
              label="Statement of Purpose"
            />

            <InputBox
              input_type="number"
              v-model="send_request.modal.commitment"
              v-bind:errors="send_request.modal_errors.commitment"
              label="Commitment (Seeking mentorships for so many months)"
            />

            <InputBox
              input_type="textarea"
              v-model="send_request.modal.expectations"
              v-bind:errors="send_request.modal_errors.expectations"
              label="Expectations from mentorship"
            />

					<!-- <InputBox input_type="textarea" v-model="send_request.modal.expectations" v-bind:errors="send_request.modal_errors.expectations"
							  label="Expectations" /> -->

					<div class="container">
						<ul>
              <div v-if = "mentee_profile.researches.length">
                <label class="label">Select Researches</label>
              </div>
              <li v-for="research in mentee_profile.researches" class="pb-2">
                <label class="checkbox pb-2" v-if="send_request.modal.researches.includes(research.uid)">
                  <input type="checkbox"
                       v-bind:key="research.uid"
                       v-bind:value="research.uid"
                       v-model="send_request.modal.researches">
                  {{ research.title }} <span style="text-transform: capitalize;"> ({{ research.category.replace('_', ' ') }}) </span>
                </label>
                <label class="checkbox pb-2" v-else>
                  <input type="checkbox"
                       v-bind:key="research.uid"
                       v-bind:value="research.uid"
                       v-model="send_request.modal.researches">
                  {{ research.title }} <span style="text-transform: capitalize;"> ({{ research.category.replace('_', ' ') }}) </span>
                </label>
              </li>
						</ul>
						<ul>
              <div v-if = "mentee_profile.achievements.length">
                <label class="label">Select Achievements</label>
              </div>
              <li v-for="achievement in mentee_profile.achievements" class="pb-2">
                <label class="checkbox pb-2" v-if="send_request.modal.achievements.includes(achievement.uid)">
                  <input type="checkbox"
                        checked
                        v-on:click="select_value"
                        v-bind:key="achievement.uid"
                        v-bind:value="achievement.uid"
                        v-model="send_request.modal.achievements">
                  {{ achievement.title }}
                </label>
                <label class="checkbox pb-2" v-else>
                  <input type="checkbox"
                        v-on:click="select_value"
                        v-bind:key="achievement.uid"
                        v-bind:value="achievement.uid"
                        v-model="send_request.modal.achievements">
                  {{ achievement.title }}
                </label>
                
              </li>
						</ul>
            <label class="label">Requirement Specified By Mentor</label>
            <p class="mb-2">Select all that apply:</p>
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul
              v-else-if="
                mentor_profile && mentor_profile.priorities && mentor_profile.priorities.length > 0
              "
            >
              <li
                v-for="priority in mentor_profile.priorities"
                v-bind:key="priority.uid"
              >
                <label>
                  <input
                    type="checkbox"
                    v-bind:key="priority.uid"
                    v-bind:value="priority.uid"
                    v-model="send_request.modal.checklist"
                  />
                  {{ priority.label }}
                  <span
                    v-bind:class="{
                      'is-danger': priority.priority === 2,
                      'is-warning': priority.priority === 1,
                      'is-success': priority.priority === 0,
                    }"
                    class="tag is-light ml-2"
                  >
                    {{ PRIORITY_VALUES[priority.priority] }}
                  </span>
                </label>
              </li>
            </ul>
            <div v-else>This mentor has not set any requirements.</div>
					</div>
          <br>
            <div v-if="send_request.modal.project">
              <label class="label">Project in which you request for mentorship</label>
              
              <div class="box p-3" v-if="send_request.modal.project_title">
                <p>
                  <span style="font-weight: bolder;">Title: </span> {{ send_request.modal.project_title }}
                  <br>
                  <span style="font-weight: bolder;">Details: </span> {{ send_request.modal.project_details }}
                </p>
                <p>
                  <span style="font-weight: bolder;" v-if="test_details">Test or assignment Details:</span> {{ send_request.modal.test_details }}
                  <br>
                  {{ send_request.modal.test_file_name }} 
                  <br>
                  <button class="button is-responsive is-primary" v-if="send_request.modal.test_file_name" v-on:click="download_file('tests_files/'+send_request.modal.test_file_name)">Download</button>
                </p>
                <br>
                <span v-if="send_request.modal.test_details || send_request.modal.test_file_name">
                  <span v-if="send_request.show_file">
                    <strong>Submission by you</strong>
                    <br>
                    <!-- <br> -->
                    {{ pending_requests.modals.request_details.content.submission_file_name }} <br>
                    <button v-on:click="download_file('submissions/'+pending_requests.modals.request_details.content.submission_file_name)" class="button is-primary">
                      Download
                    </button>
                    <button v-on:click="send_request.show_file = false" class="button is-danger">
                      Delete
                    </button>
                  </span>
                  <span v-else>
                    Submit test solution file:
                    <input type="file" name="" id="test_file" v-on:change="handleFile" ref="file" required>
                  </span>
                </span>
              </div>
            </div>
            
          </section>

          <footer class="modal-card-foot">
            <div class="columns is-mobile" style="width: 100%">
              <div class="column has-text-right">
                <button
                  v-on:click="send_mentorship_request"
                  class="button is-success"
                >
                  Send
                </button>
                <button
                  v-on:click="send_request.show_send_request_modal = false"
                  class="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </footer>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios, { API_URL } from '../../api/my-axios';
import InputBox from '../../components/FormHelpers/InputBox';
import FormErrors from '../../components/FormHelpers/FormErrors';
import { PRIORITY_VALUES } from '../../lib';

export default {
  components: {
    FormErrors,
    InputBox,
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      send_request: {
        show_file: true,
        show_send_request_modal: false,
        modal: {
          request_uid: "",
          statement_of_purpose: "",
          commitment: "",
          expectations: "",
          researches: [],
          achievements: [],
          checklist: [],
          project: "",
          mentor: "",
          profile: "",
          project_title: "", 
          project_details: "",
          test_file_name: null,
          file: null,
        },
        modal_errors: {},
      },

      PRIORITY_VALUES,

      mentor_profile: {},

      mentee_profile: {
				researches: [],
				achievements: [],
			},

      pending_requests: {
        errors: {},

        data: [{}],

        modals: {
          reject_reason: {
            show: false,
            content: {
              status: 1,
              reject_reason: '',
              block : false,
            },
            errors: {},
          },

          request_details: {
            show: false,
            status: 2,
            content: {
              statement_of_purpose: '',
              commitment: '',
              expectations: '',
              researches: [],
              achievements: [],
              checklist: [],
              project_title: "",  
              submission_file: null,
              submission_file_name: null,
            },
          },
        },
      },
    };
  },
  created() {
    this.get_pending_mentorship_requests();
    this.find_mentee_research();
    this.find_mentee_achievement();
  },
  methods: {
    get_pending_mentorship_requests() {
      axios
        .get('/api/mentorship/request/pending/', {
          params: {
            mentee: this.user.profile_uid,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.pending_requests.data = response.data;
        })
        .catch((error) => {
          this.pending_requests.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    find_mentee_research() {
			axios
				.get(`/api/mentee/research/`, {
					params: {
						mentee: this.user.profile_uid,
					}
				})
				.then(response => {
					this.mentee_profile['researches'] = response.data;
				})
				.catch(error => {
					console.error(error);
				});
		},

    find_mentee_achievement() {
			axios
				.get(`/api/mentee/achievement/`, {
					params: {
						mentee: this.user.profile_uid,
					}
				})
				.then(response => {
					this.mentee_profile['achievements'] = response.data;
				})
				.catch(error => {
					console.error(error);
				});
		},

    cancel_pending_request(index) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }

      axios
        .delete(
          `/api/mentorship/request/${this.pending_requests.data[index].uid}/`,
          {}
        )
        .then((_) => {
          this.pending_requests.data.splice(index, 1);
        })
        .catch((error) => {
          this.pending_requests.errors = error.response.data;
        });
    },

    open_send_request_modal(index) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }
      this.get_mentor_details(this.pending_requests.data[index]['mentor']);
      for (const key in this.send_request.modal) {
        this.send_request.modal[
          key
        ] = this.pending_requests.data[index][key];
      }
      this.send_request.modal.request_uid = this.pending_requests.data[index]['uid'];
      this.pending_requests.modals.request_details.content.submission_file_name = this.pending_requests.data[index]['submission_file_name'];
      // this.pending_requests.modals.reject_reason.content.reject_reason = this.pending_requests.data[index]['reject_reason']
      // this.pending_requests.modals.reject_reason.content.status = this.pending_requests.data[index]['status']
      
      this.send_request.show_send_request_modal = true;
    },

    show_request_details(index) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }

      for (const key in this.pending_requests.modals.request_details.content) {
        this.pending_requests.modals.request_details.content[
          key
        ] = this.pending_requests.data[index][key];
      }
      this.pending_requests.modals.reject_reason.content.reject_reason = this.pending_requests.data[index]['reject_reason']
      this.pending_requests.modals.reject_reason.content.status = this.pending_requests.data[index]['status']
      
      this.pending_requests.modals.request_details.show = true;
    },

    download_file(file_name){
      console.log(API_URL)
      var url = API_URL+ 'media/'+file_name;
      window.open(url, '_blank');
    },

    get_mentor_details(profile_uid)
		{
			axios
				.get(`/api/mentor/mentor/${profile_uid}/`)
				.then(response => {
					this.mentor_profile = response.data;
				})
				.catch(error => {
					console.error(error);
				});
		},

    send_mentorship_request() {
      console.log("sending this =" + this.model)
      const headers = { 'Content-Type': 'multipart/form-data' };
      const formdata = new FormData();
      formdata.append('mentee', this.user.profile_uid)
      formdata.append('mentor', this.send_request.modal.mentor)
      formdata.append('project', this.send_request.modal.project)
      formdata.append('status', 1) // status = 1 (pending request)
      formdata.append('statement_of_purpose', this.send_request.modal.statement_of_purpose)
      formdata.append('commitment', this.send_request.modal.commitment)
      formdata.append('expectations', this.send_request.modal.expectations)
      if (this.send_request.modal.file){
        formdata.append('file', this.send_request.modal.file)
      }
      if(this.send_request.modal.researches.length > 0){
        this.send_request.modal.researches.forEach((item) => formdata.append("researches", item))

        // formdata.append('researches', JSON.stringify(this.send_request.modal.researches))
      }
      if(this.send_request.modal.checklist.length > 0){
        this.send_request.modal.checklist.forEach((item) => formdata.append("checklist", item))
        // formdata.append('checklist', JSON.stringify(this.send_request.modal.checklist))
      }
      if(this.send_request.modal.achievements.length > 0){
        this.send_request.modal.achievements.forEach((item) => formdata.append("achievements", item))
        // formdata.append('achievements', JSON.stringify(this.send_request.modal.achievements))
      }
      axios
        .put(`/api/mentorship/request/${this.send_request.modal.request_uid}/`, formdata, {headers})
        .then((response) => {
          this.send_request.show_send_request_modal = false;
          this.get_pending_mentorship_requests();
        })
        .catch((error) => {
          this.send_request.modal_errors = error.response.data;
        });
    },

    handleFile(){
      this.send_request.modal.file = this.$refs.file.files[0];
    },

    get_status(status){
      if (status == 1){
        return "Pending";
      }
      else if (status == 2){
        return "Accepted";
      }
      else if (status == 3){
        return "Rejected";
      }
      else if (status == 4){
        return "Resubmit";
      }
    },
  },
};
</script>

<style scoped>
.pending-requests td {
  border: none !important;
}
</style>

<style scoped>
.search-results td,
.search-options td {
  border: none !important;
}
</style>